import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import { WindowRef } from '../common/helpers';
import { ApplicationConfig } from './config';

declare let delta: any;

@Injectable({
  providedIn: 'root'
})
export class UrlUtil {
  private _protoUrl;
  private _requestObject: any;
  private _customerUrl;
  private countrycodeconfig;
  private computeUrl: void;

  constructor(
    private injector: Injector,
    @Inject(PLATFORM_ID) private platformId: Object,
    private config: ApplicationConfig,
    private winRef: WindowRef
  ) {
    const url_mapping = this.config.get('APP_URL_MAPPINGS');
    if (url_mapping) {
      this.countrycodeconfig = JSON.parse(url_mapping);
    }
    this.computeUrl = this._computeBaseUrl();
  }

  // private _baseUrlPrefixed;
  private _baseUrl;

  /**
   * returns the HOST URL prefixed with the APP WEB CONTEXT
   * e.g. localhost:9000/app
   */
  get baseUrl() {
    return `${this.hostUrl}/${this.config.get('APP_CONTEXT_ROOT')}`;
  }

  private _basePort;

  get basePort() {
    return this._basePort;
  }

  private _hostUrl;

  /**
   * returns the HOST URL without the APP WEB CONTEXT
   * e.g. https://localhost:9000 or http://localhost:9000
   */
  get hostUrl() {
    return `//${window.location.host}`;
  }

  private _aemUrl;

  get aemUrl() {
    return this._aemUrl;
  }

  private _utilUrl;

  get utilUrl() {
    return this._utilUrl;
  }

  private _predictiveUrl;

  get predictiveUrl() {
    return this._predictiveUrl;
  }

  private _profileUrl;

  get profileUrl() {
    return this._profileUrl;
  }

  get custUrl() {
    return this._customerUrl;
  }

  /**
   * TODO - use require('query-string') package for conversion
   * @param obj - JSON object to be converted to URL params
   */
  toObjQueryString(obj) {
    return Object.keys(obj).reduce(function (str, key, i) {
      let delimiter, val;
      delimiter = i === 0 ? '' : '&';
      key = encodeURIComponent(key);
      val = encodeURIComponent(obj[key]);
      return [str, delimiter, key, '=', val].join('');
    }, '');
  }

  getCountryCodeForUrl(countrycode) {
    if (
      this.countrycodeconfig &&
      countrycode &&
      this.countrycodeconfig[countrycode]
    ) {
      return this.countrycodeconfig[countrycode];
    }
    return this.config.get('APP_DEFAULT_COUNTRY');
  }

  getURLParam(parameter: string, defaultvalue: any): any {
    const parameterList = window.location.search.substring(1);
    const keyValueList = parameterList.split('&');
    for (let i = 0; i < keyValueList.length; i++) {
      const keyValueSet = keyValueList[i].split('=');
      if (keyValueSet[0] === parameter) {
        return keyValueSet[1];
      }
    }
    return defaultvalue;
  }

  private _computeBaseUrl() {
    if (isPlatformServer(this.platformId)) {
      this._requestObject = this.injector.get('REQUEST_TOKEN');
      const environment = this.injector.get('ENVIRONMENT_TOKEN');
      // return domain.com instead of domain.com:9000 if environment is not local

      const hostname =
        environment === 'local'
          ? this._requestObject.headers.host
          : this._requestObject.hostname;
      this._hostUrl = `${this._requestObject.protocol}://${hostname}`;
      this._baseUrl = `${this._hostUrl}/${this.config.get('APP_CONTEXT_ROOT')}`;
      this._basePort = this._requestObject.headers.host
        ? this._requestObject.headers.host.split(':')[1]
        : '';
      this._aemUrl =
        environment === 'local'
          ? this._hostUrl
          : `${this._requestObject.protocol}://${process.env.WEBSERVER_HOSTNAME}`;

      this._customerUrl =
        environment === 'local'
          ? this._hostUrl
          : `${this._requestObject.protocol}://${process.env.CUSTOMER_JVM}`;
      this._utilUrl =
        environment === 'local'
          ? this._hostUrl
          : `${this._requestObject.protocol}://${process.env.UTIL_JVM}`;
      this._profileUrl =
        environment === 'local'
          ? this._hostUrl
          : `${this._requestObject.protocol}://${process.env.PROFILE_JVM}`;
      this._predictiveUrl =
        environment === 'local'
          ? this._hostUrl
          : `${this._requestObject.protocol}://${process.env.PREDICTIVE_JVM}`;
    } else {
      this._protoUrl = `${this.winRef.getProtocol()}//`;
      this._hostUrl = `${this._protoUrl}${this.winRef.getHost()}`;
      this._baseUrl = `${this._hostUrl}/${this.config.get('APP_CONTEXT_ROOT')}`;
      this._basePort = this.winRef.getPort();
      this._aemUrl = this._hostUrl;
      // this._aemUrl =  this.winRef.getOrigin().indexOf('local') > 1 ? this._hostUrl : `${this.winRef.getProtocol()}//${this.config.get('APP_AEM_HOST')}`;
      this._customerUrl = this._hostUrl;
      this._utilUrl = this._hostUrl;
      this._profileUrl = this._hostUrl;
      this._predictiveUrl = this._hostUrl;
    }
  }
}
